module.exports = __webpack_public_path__ + "static/img/m_role.b773a87.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/yjyx/m_role.png
// module id = Zfn3
// module chunks = 7